import { RecoilRoot } from 'recoil';

import QueryClientProvider from '../../components/QueryClientProvider';
import { LAYOUT, COLOR, Variation } from '../../types/globalSearch';

import GlobalSearchContainer from './GlobalSearchContainer';
import LogDataContext, { type LogData } from './LogDataContext';
import { forwardRef } from 'react';

const DEFAULT_VARIATION: Variation = {
  layout: LAYOUT.header,
  color: COLOR.white,
};

interface Props {
  placeholder: string;
  variations?: Variation;
  isShowSearchInput?: boolean;
  isSuggestionDialogOpen?: boolean;
  onSuggestionDialogToggle?: (isOpen: boolean) => void;
  className?: string;
  logData?: LogData;
}

function GlobalSearch(
  {
    variations = DEFAULT_VARIATION,
    placeholder,
    isShowSearchInput = true,
    isSuggestionDialogOpen,
    onSuggestionDialogToggle,
    className,
    logData,
  }: Props,
  ref: React.ForwardedRef<HTMLInputElement>,
) {
  return (
    <RecoilRoot>
      <QueryClientProvider>
        <LogDataContext.Provider value={logData}>
          <GlobalSearchContainer
            variations={variations}
            placeholder={placeholder}
            isShowSearchInput={isShowSearchInput}
            isSuggestionDialogOpen={isSuggestionDialogOpen}
            onSuggestionDialogToggle={onSuggestionDialogToggle}
            className={className}
            ref={ref}
          />
        </LogDataContext.Provider>
      </QueryClientProvider>
    </RecoilRoot>
  );
}

export default forwardRef(GlobalSearch);
